import {
    postNewDeliveryPointRouteLoading,
    postNewDeliveryPointRouteRequest,
    postNewDeliveryPointRouteSuccess,
    postNewDeliveryPointRouteReject,
    postNewDeliveryPointRouteReset
} from "../../actions/route/postDeliveryPointTemplate";

export const postNewDeliveryPointRoute = ({ formData, idRoute }) => async (dispatch, getState) => {
    dispatch(postNewDeliveryPointRouteLoading());
    try {
        const { data } = await postNewDeliveryPointRouteRequest(formData, idRoute, getState);
        dispatch(postNewDeliveryPointRouteSuccess(data))
    } catch (error) {
        dispatch(postNewDeliveryPointRouteReject(error))
    } finally {
        setTimeout(() => { dispatch(postNewDeliveryPointRouteReset()) }, 3000);
    }
    return Promise.resolve();
};